import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyIspettivaService {
    static checklistTipi = (id_azienda = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/checklistTipi`;
            ApiService.postRequest(resolve, reject, url, id_azienda ? { id_azienda } : {});
        });
    };

    static checklistByAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/checklistByAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static saveChecklistItem = (payload) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/saveChecklistItem`;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static stats = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/stats`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static verbaliByAzienda = (id_azienda, soloAperti = false) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/verbaliByAzienda`;
            ApiService.postRequest(resolve, reject, url, {
                id_azienda,
                solo_aperti: soloAperti ? 1 : 0,
            });
        });
    };

    static createVerbale = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/createVerbale`;
        return ApiService.postFormData(url, formData);
    };

    static updateVerbale = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/updateVerbale`;
        return ApiService.postFormData(url, formData);
    };

    static deleteVerbale = (id_verbale) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/deleteVerbale`;
            ApiService.postRequest(resolve, reject, url, { id_verbale });
        });
    };

    static downloadVerbale = (id_verbale, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/downloadVerbale`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_verbale, filename });
        });
    };

    static exportFascicolo = (id_azienda, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/ispettiva/exportFascicolo`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_azienda, filename });
        });
    };
}
